import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Header = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 180px;
    height: 80px;
    background: rgba(0, 0, 0, 0.2);
    z-index: 2;

    display: flex;
    flex-direction: column;
`

export const TitleWrap = styled(Link)`
    flex: 0 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-decoration: none;

    &:hover > * {
        color: white;
    }
`

export const Title = styled.h1`
    color: ${p => p.theme.accentColor};
    font-size: 1.6em;
    font-weight: 200;
    font-style: italic;
    margin: 0;

    transition: color 0.25s ease-in;
`
export const Subtitle = styled.h3`
    font-size: 1em;
    line-height: 1.6em;
    font-weight: 400;
    font-style: italic;
    color: white;
    margin: 6px 0 0 10px;
`



// WEBPACK FOOTER //
// ./src/components/Header.styles.js